import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';

import { enUS } from 'date-fns/locale';
@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string): unknown {
    // Remove the 'Z' to prevent timezone conversion
    const dateString = typeof value === 'string' ? value.replace(/Z$/, '') : value;
    var date = new Date(dateString);
    return formatDistanceToNow(date);
  }
}
